export default __webpack_public_path__ + "static/media/gif.1e13fff2.gif";